/* global document */
document.documentElement.classList.add('js-enabled');
const toggle = document.querySelector('.nav-toggle');
const navigation = document.querySelector('.primary-nav');
toggle?.addEventListener('click', () => {
  const open = navigation.classList.toggle('open');
  toggle.setAttribute('aria-expanded', String(open));
  toggle.querySelector('.sr-only').textContent = open ? 'Close menu' : 'Open menu';
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape' || !navigation?.classList.contains('open')) return;
  navigation.classList.remove('open');
  toggle.setAttribute('aria-expanded', 'false');
  toggle.querySelector('.sr-only').textContent = 'Open menu';
  toggle.focus();
});
